import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import FeatureGrid from './components/FeatureGrid';
import CategoryScroll from './components/CategoryScroll';
import ArticleGrid from './components/ArticleGrid';
import AboutBrand from './components/AboutBrand';
import SafetyComparison from './components/SafetyComparison';
import FAQSection from './components/FAQSection';
import CTABanner from './components/CTABanner';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <FeatureGrid />
        <CategoryScroll />
        <ArticleGrid />
        <AboutBrand />
        <SafetyComparison />
        <FAQSection />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}